<template>
    <div class="tr" :class="active ? 'bg-yellow-500': ''" @click="highlightMe">
        <div class="td">
            <div v-if="stringLayout.isUnderRevision" class="text-purple-600 mr-2" v-tooltip="'In Revisione'">
                <i class="fab fa-whmcs"></i>
            </div>
            {{ stringLayout.harp.nome }}
        </div>
        <div class="td" style="flex-grow: 2" v-if="policies.update">
            <editable-cell-input :id="stringLayout.id"
                                 :data="stringLayout.descrizione"
                                 field="descrizione"
                                 url="/strings-layouts/"
            >
            </editable-cell-input>
        </div>
        <div class="td" style="flex-grow: 2" v-else>{{ stringLayout.descrizione }}</div>
        <div class="td capitalize">{{ stringLayout.string_layout_type_description }}</div>
        <div class="td">{{ stringLayout.tuning }}</div>
        <div class="td">{{ stringLayout.revisione }}</div>
        <div class="td" v-if="policies.update">
            <editable-cell-date-picker :id="stringLayout.id"
                                       :data="stringLayout.validity_date | reversed"
                                       field="validity_date"
                                       :url="/strings-layouts/"
            >

            </editable-cell-date-picker>
        </div>
        <div class="td" v-else>{{ stringLayout.validity_date | reversed }}</div>
        <div class="td capitalize">{{ stringLayout.status }}</div>
        <div class="td justify-center">

            <string-layout-controls
                    :string-layout="stringLayout"
                    :policies="policies"
                    :under-revision="stringLayout.isUnderRevision"
                    @duplicate="duplicate"
            ></string-layout-controls>
        </div>
    </div>
    
</template>

<script>
    import EditableCellInput from '../EditableCellInput';
    import EditableCellDatePicker from '../EditableCellDataPicker';
    import StringLayoutControls from './single-string/StringLayoutControls';

    export default {

        inject: ['StringsLayoutsListState'],

        components: {
            EditableCellInput,
            EditableCellDatePicker,
            StringLayoutControls,
        },

        props: {
            stringLayout: {},
            policies: {}
        },

        data() {
            return {
                target: {},
                rowId: this.stringLayout.id
            }
        },

        filters: {
            reversed(date) {
                if (date != null) {
                    return date.split('-').reverse().join('-')
                }
            }
        },

        computed: {
            active() {
                return this.StringsLayoutsListState.activeItem === this.rowId;
            }
        },

        methods: {
            duplicate(target) {
                this.StringsLayoutsListState.targetItem = target;
                this.$modal.show('add-strings-layout');
            },

            highlightMe() {
                this.StringsLayoutsListState.activeItem = this.rowId;
            }
        }

    }
</script>
